import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

/**
 * El ancho de página del portal, en un solo lugar.
 *
 * Todo lo que se apila en pantalla —encabezado, fila de herramientas y
 * contenido— usa este contenedor, así los bordes izquierdo y derecho caen
 * siempre sobre la misma línea: el logo arriba a la izquierda y el avatar
 * arriba a la derecha marcan esa línea, y nada la cruza.
 *
 * El tope es ancho a propósito. Esto es una herramienta de trabajo, no una
 * página de lectura: cuanta más pantalla se aproveche, más piezas entran sin
 * desplazarse. Desde 1536 px (Full HD, también al 125 %) se abre a 1680 px:
 * con el tope de 1280 un monitor grande se veía igual que uno de 1360.
 */
export function Pagina({
  children,
  className,
  as: Elemento = 'div',
}: {
  children: ReactNode
  className?: string
  as?: 'div' | 'main'
}) {
  return (
    <Elemento
      className={cn(
        'mx-auto w-full max-w-7xl px-4 sm:px-6 2xl:max-w-[105rem]',
        className,
      )}
    >
      {children}
    </Elemento>
  )
}
